import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { GlobalService } from '@app/services/global.service';

@Component({
  selector: 'app-save-problem-report-button',
  templateUrl: './save-problem-report-button.component.html',
  imports: [NgbTooltip, AsyncPipe],
})
export class SaveProblemReportButtonComponent {
  private globalService = inject(GlobalService);

  problemReportSavingRunning$ = this.globalService.problemReportSavingRunning$;

  onSaveProblemReport() {
    this.globalService.requestSaveProblemReport();
  }
}
